/**
* Search results
*/

( function( $ ) {
	let ajaxLock = false;

	$( '#search-results-content .load-more-btn' ).on( 'click', function() {
		let nonce, totalposts, perPage, searched;

		nonce      = $( this ).data( 'nonce' );
		totalposts = parseInt( $( this ).data( 'totalresult' ) );
		perPage    = parseInt( $( this ).data( 'perpage' ) );
		searched   = $( this ).data( 'searched' );

		console.log(totalposts);

		ajaxLoadMoreSearchResults( nonce, totalposts, perPage, searched );
	});

	const ajaxLoadMoreSearchResults = ( nonce, totalposts, perPage, searched ) => {
		ajaxLock = true;
		let offset = parseInt( $( '#search-results-content .search-result' ).length );

		$.ajax({
			method: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'load_more_search_results',
				nonce: nonce,
				perPage: perPage,
				offset: offset,
				searched: searched,
			}
		})
		.done( function( response ) {

			if ( response.data.succcess == 'true') {
			}
			$( response.data.content ).insertAfter( '#search-results-content .search-result:last' );
			let loadedSearchResults = parseInt( $( '#search-results-content .search-result' ).length );

			if ( 0 >= (totalposts - loadedSearchResults) ) {
				$( '#search-results-content .load-more-search-results' ).hide();
			}


			ajaxLock = false;
			console.log( 'Success' );
			console.log( response.data );
			console.log( response.data.success );
		})
		.fail( function( jqXHR, textStatus, errorThrown ) {
			ajaxLock = false;

			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);

			console.log( 'Failed' );
		});
	}
})(jQuery);
